import styled from 'styled-components';
import { Flex, FlexColumn, IconButton } from '@elementary/common-ui/components';
import {
  fontSize,
  lineHeight,
  radius,
  space,
} from '@elementary/common-ui/style/utils';

export const Wrapper = styled(FlexColumn)`
  height: 100%;
  gap: ${space('xxl')};
  position: relative;
  overflow: hidden;
`;

export const Header = styled(Flex)`
  align-items: center;
  justify-content: space-between;
  padding: ${space('xxl', 'lg', 'sm', 'lg')};
`;

export const HeaderNavigation = styled(Flex)`
  align-items: center;
  gap: ${space('lg')};
  min-width: 0;
  flex: 1;
`;

export const BackButton = styled(IconButton)`
  svg path {
    fill: ${({ theme }) => theme.palette.icon.faint} !important;
  }

  &:hover svg path {
    fill: ${({ theme }) => theme.palette.icon.primary} !important;
  }
`;

export const HeaderActions = styled(Flex)`
  align-items: center;
  gap: ${space('md')};
`;

export const SelectedCountLabel = styled.span`
  font-size: ${fontSize('md')};
  color: ${({ theme }) => theme.palette.content.disabled};
`;

export const SkipSummary = styled.span`
  font-size: ${fontSize('md')};
  color: ${({ theme }) => theme.palette.content.disabled};
  padding: ${space(0, 'lg')};
`;

export const DraftPrBanner = styled(Flex)`
  margin: ${space(0, 'lg')};
  padding: ${space('smMinus', 'lg')};
  align-items: center;
  background: ${({ theme }) => theme.palette.surface.sunken};
  border-radius: ${radius('lg')};
`;

export const DraftPrParagraph = styled(Flex)`
  flex: 1;
  padding: ${space('sm', 0)};
  align-items: center;
  justify-content: space-between;
`;

export const DraftPrSummary = styled(Flex)`
  align-items: center;
  gap: ${space('xs')};
  font-size: ${fontSize('base')};
  line-height: ${lineHeight('md')};
  color: ${({ theme }) => theme.palette.content.primary};
`;

export const DraftPrNumbers = styled(Flex)`
  align-items: center;
  gap: ${space('xs')};
`;

export const DraftPrDeletions = styled.span`
  font-size: ${fontSize('base')};
  line-height: ${lineHeight('md')};
  color: ${({ theme }) => theme.palette.status.error.bright};
`;

export const DraftPrAdditions = styled.span`
  font-size: ${fontSize('base')};
  line-height: ${lineHeight('md')};
  color: ${({ theme }) => theme.palette.status.success.main};
`;

export const DraftPrLink = styled.a`
  margin-left: auto;
  font-size: ${fontSize('base')};
  line-height: ${lineHeight('md')};
  color: ${({ theme }) => theme.palette.accent.primary};
  text-decoration: underline;
  white-space: nowrap;
  cursor: pointer;
`;

export const TableContainer = styled(FlexColumn)`
  flex: 1;
  min-height: 0;
  padding: ${space(0, 'lg', 'lg', 'lg')};
  z-index: 0;
`;

export const EmptyState = styled(FlexColumn)`
  align-items: center;
  justify-content: center;
  flex: 1;
  gap: ${space('lg')};
  color: ${({ theme }) => theme.palette.content.disabled};
`;

export const CellFlex = styled(Flex)`
  align-items: center;
  gap: ${space('sm')};
  max-width: 100%;
  overflow: hidden;
`;

export const FixedChipWrapper = styled.div`
  flex-shrink: 0;
`;

export const ElasticChipWrapper = styled.div`
  min-width: 0;
  flex: 1;

  .MuiChip-root {
    max-width: 100%;
  }

  .MuiChip-label {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const ShrinkableChipWrapper = styled.div`
  min-width: 0;
  flex-shrink: 1;

  .MuiChip-root {
    max-width: 100%;
  }

  .MuiChip-label {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;
